import { IParentPropertySubType } from './../models/property-subtypes';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from '.';

const baseUrl = '/api/Admin/PropertySubType';

export const PropertySubTypeAPI = {
  /**
   * Fetch the latest list of all Property SubTypes.
   */
  async getAll(): Promise<IParentPropertySubType[]> {
    try {
      const response: AxiosResponse<IParentPropertySubType[]> = await authFetch.get(`${baseUrl}`);

      // Check if status is in the 2XX range
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  /**
   * Create and update an array of given records.
   */
  async upsert(records: IParentPropertySubType[]): Promise<IParentPropertySubType[]> {
    try {
      const response: AxiosResponse<IParentPropertySubType[]> = await authFetch.post(
        `${baseUrl}`,
        records
      );

      // Check if status is in the 2XX range
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },

  async delete(PropertySubTypeId: number): Promise<void> {
    try {
      await authFetch.delete(`${baseUrl}/${PropertySubTypeId}`);
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return Promise.reject(err?.response?.data);
      }
      return Promise.reject(err);
    }
  },
};
